import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { PrismCard, PrismIcon, PrismMessage } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import HotelStrategySubtypeMetricBlock from 'lumen/components/hotel/strategy/subtype-metric-block';
import {
  SUBTYPE_VALUES_KEY_CANCELLATION_POLICY,
  SUBTYPE_VALUES_KEY_STRATEGY,
} from 'lumen/utils/constants/rate-strategy-constants';

interface HotelStrategyTypeCardSignature {
  Args: {
    data: unknown;
    isLoading: unknown;
    nbOfRowsInCard: unknown;
    switchToDetailViaPositionButton: unknown;
    switchToDetailViaTitleExpand: unknown;
    useSingleRowLayout: unknown;
  };
  Blocks: {
    default: [];
  };
}

export default class HotelStrategyTypeCard extends Component<HotelStrategyTypeCardSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasThreeOrMoreColumns() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const numOfTiles = this.args.data.filteredSubtypes.length;
    return numOfTiles > 4 || (this.args.useSingleRowLayout && numOfTiles > 2);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get useSingleRowLayout() {
    return this.args.nbOfRowsInCard === 1;
  }

  <template>
    {{! @glint-nocheck }}
    {{! template-lint-disable require-presentational-children }}
    {{#unless @data.isNotOffered}}
      <PrismCard
        @contentLayout="borderedHeader"
        @isParent={{true}}
        class="rate-strategy-card"
      >
        <:header as |Header|>
          <div
            class="button--unstyled flex items-center justify-between"
            role="button"
            {{on "click" (fn @switchToDetailViaTitleExpand @data.name)}}
          >
            {{#if @isLoading}}
              <p class="segmentation-value-loading-state-bar"></p>
            {{else}}
              <div class="flex items-center justify-start gap-200">
                {{#if @data.icon}}
                  <PrismIcon @name={{@data.icon}} />
                {{/if}}
                <Header.title>
                  {{@data.formattedTypeName}}
                </Header.title>
              </div>
            {{/if}}
            <span class="ic-product-tour-rate-strategy-expand">
              <PrismIcon @name="expand" />
            </span>
          </div>
        </:header>
        <:content>
          {{#if @isLoading}}
            {{! Same container class as used in the SubtypeMetricBlock component }}
            <div
              class="rate-strategy-subtype-metric-block rate-strategy-subtype-metric-block--loading"
            ></div>
          {{else}}
            <div
              class="rate-strategy-card__content dynamic-layout--grid-styling
                {{if @data.isMissing 'dynamic-layout--grid-styling--no-data'}}
                {{if
                  this.hasThreeOrMoreColumns
                  'dynamic-layout--grid-styling--col3'
                }}
                {{if
                  this.useSingleRowLayout
                  'dynamic-layout--grid-styling--single-row'
                }}"
            >
              {{! show card empty state if the type is missing }}
              {{#if @data.isMissing}}
                <div class="rate-strategy-subtype-empty-state-wrapper">
                  <PrismMessage
                    @description={{t "stategy.empty_state.partial.message"}}
                    @illustration="100x100_progress"
                    @title={{t "general.empty_state.title.crunching_numbers"}}
                  />
                </div>
              {{else}}
                {{#each @data.filteredSubtypes as |subtype|}}
                  {{#unless subtype.isExcludedFromSummaryView}}
                    {{#if subtype.hasCancellationPolicies}}
                      <HotelStrategySubtypeMetricBlock
                        @dataToShow={{SUBTYPE_VALUES_KEY_CANCELLATION_POLICY}}
                        @subtype={{subtype}}
                      />
                    {{/if}}

                    {{#if subtype.hasStrategies}}
                      <HotelStrategySubtypeMetricBlock
                        @dataToShow={{SUBTYPE_VALUES_KEY_STRATEGY}}
                        @subtype={{subtype}}
                        @switchToDetailViaPositionButton={{@switchToDetailViaPositionButton}}
                      />
                    {{/if}}
                  {{/unless}}
                {{/each}}
                {{yield}}
              {{/if}}
            </div>
          {{/if}}
        </:content>
      </PrismCard>
    {{/unless}}
  </template>
}
